import React, {useCallback, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Nav, OverlayTrigger, Tooltip} from "react-bootstrap";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {useDetectAdBlock} from "adblock-detect-react";
import {useAuthentication, useAuthorization} from "../../hooks";
import {AuthState} from "../../store";
import {useConfirmNavigation} from "../../hooks/useConfirmNavigation";

const Navigation: React.FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const adBlockDetected = useDetectAdBlock();
    const {authState} = useAuthentication();
    const [activeKey, setActiveKey] = useState<string>("/image-matcher");

    const {isBlocking} = useConfirmNavigation();

    const {hasVectorizationPermission, hasImageGenerationPermission} = useAuthorization();

    useEffect(() => {
        const path = location.pathname;

        if (adBlockDetected) {
            toast.warning(t("AdblockAlert"));
        }

        // Prevent updating activeKey if navigation is blocked
        if (!isBlocking) {
            setActiveKey(path.startsWith("/image-matcher") ? "/image-matcher" : path);
        }
    }, [location, adBlockDetected, t, isBlocking]);

    const handleClick = useCallback(
        (selectedKey: string) => {
            if (selectedKey !== activeKey) {
                navigate(selectedKey);
            }
        },
        [activeKey, navigate]
    );

    const renderTooltip = (props: any) => (
        <Tooltip id="button-tooltip" {...props}>
            {t("OnlyMatchToOEM.MatchesPairsToolTips")}
        </Tooltip>
    );

    if (authState !== AuthState.SignedIn) return null;

    return (
        <Nav className="navbar-custom" variant="pills" activeKey={activeKey}>
            <Nav.Item>
                <Nav.Link eventKey="/image-matcher" style={{color: "black"}}
                          onClick={() => handleClick("/image-matcher")}>
                    {t("ExtractedImages.ImageMatcher")}
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="/special-tools-finder" style={{color: "black"}}
                          onClick={() => handleClick("/special-tools-finder")}>
                    {t("Manual.ManualFinder")}
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={renderTooltip} rootClose>
                    <Nav.Link eventKey="/matched-pairs" style={{color: "black"}}
                              onClick={() => handleClick("/matched-pairs")}>
                        {t("OnlyMatchToOEM.MatchesPairs")}
                    </Nav.Link>
                </OverlayTrigger>
            </Nav.Item>
            {hasVectorizationPermission && <Nav.Item>
                <Nav.Link eventKey="/vectorization" style={{color: "black"}}
                          onClick={() => handleClick("/vectorization")}>
                    {t("Vectorization.Title")}
                </Nav.Link>
            </Nav.Item>}
            {hasImageGenerationPermission && <Nav.Item>
                <Nav.Link eventKey="/image-generation" style={{color: "black"}}
                          onClick={() => handleClick("/image-generation")}>
                    {t("ImageGeneration.Title")}
                </Nav.Link>
            </Nav.Item>}
        </Nav>
    );
};

export default Navigation;
